module.exports = __webpack_public_path__ + "media/index3.82eef44d.webm";